import React from 'react';
import {HashRouter, Route,Switch} from "react-router-dom";
import BasicLayout from '../layouts/basicLayout.jsx'
import ErrPage from '../pages/errPage/index.jsx'
class RouteMap extends React.Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route path='/' exact component={BasicLayout}/>
          <Route path='/apm' component={BasicLayout}/>
          <Route path='/errPage' exact component={ErrPage}/>
        </Switch>
      </HashRouter>
    )
  }
}

export default RouteMap
